/* Westerly featured tabs: accessible tablist with roving tabindex. */
if (!customElements.get('westerly-tabs')) {
  customElements.define(
    'westerly-tabs',
    class WesterlyTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabs.length) return;

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
      }

      onClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        this.select(tab);
      }

      onKeydown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;
        const index = this.tabs.indexOf(tab);
        if (index === -1) return;

        let next = null;
        if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
        if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        if (event.key === 'Home') next = this.tabs[0];
        if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
        if (!next) return;

        event.preventDefault();
        this.select(next);
        next.focus();
      }

      select(tab) {
        this.tabs.forEach((t) => {
          const selected = t === tab;
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          if (selected) {
            t.removeAttribute('tabindex');
          } else {
            t.setAttribute('tabindex', '-1');
          }
        });
        this.panels.forEach((panel) => {
          if (panel.id === tab.getAttribute('aria-controls')) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }
    }
  );
}
